export const AEU_BLOCKED_WIDGETS = [
    'productAreasOverviewChart',
    'objectAnalyticsKeyMetrics',
    'objectAnalyticsChart',
    'timeToNth',
];

export const AEU_ANALYTICS_BLOCKED_WIDGETS = [
    'accountFrequency',
    'accountOverview',
    'appUsage',
    'appVersion',
    'browserUsageChart',
    'customReportChart',
    'deviceUsage',
    'embedIframeCode',
    'featureAdoption',
    'featureOverview',
    'featureUseByAccount',
    'featureUseByVisitor',
    'funnelReportChart',
    'goalProgress,',
    'osVersion',
    'osChart',
    'pageOverview',
    'pageUseByAccount',
    'pageUseByVisitor',
    'pageFeatureUseOverTime',
    'pesTrending',
    'productEngagementScore',
    'retentionReportChart',
    'retentionByUsage',
    'stickinessMetric',
    'timeToFirstUse',
    'topAccounts',
    'topVisitors',
    'totalTimeOnAppPerWeek',
    'trackEventUseByAccount',
    'trackEventUseByVisitor',
    'trackEventKeyMetrics',
    'weeklyAccounts',
];
